import { lazy, memo, Suspense } from "react"
import { useCore } from "@app/hooks/useCore"
import { useMedia } from "@app/hooks/useMedia"

const Story: React.FC<GatsbyTypes.SanitySectionStory> = props => {
  const {
    helpers: { ErrorBoundary },
  } = useCore()
  const { isMedium } = useMedia()

  const StoryDesktop = lazy(() => import("./StoryDesktop"))
  const StoryMobile = lazy(() => import("./StoryMobile"))

  return (
    <ErrorBoundary>
      <Suspense fallback={null}>{isMedium ? <StoryDesktop {...props} /> : <StoryMobile {...props} />}</Suspense>
    </ErrorBoundary>
  )
}

export default memo(Story)
